import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import ProductTag from '../../../components/ProductTag';
import { useMediaQuery } from '../../../utils/hooks';
import { hubspotEditPagePaths } from '../../../utils/urls';
import { useUserByUsername, useIsCurrentUser } from '../userQueries';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';

const UserProducts = ({
  username
}) => {
  const {
    user
  } = useUserByUsername(username);
  const ownProfile = useIsCurrentUser(user ? user.userId : undefined);
  const screenLarge = useMediaQuery(`(min-width: ${GRID_BREAKPOINT_SMALL})`);
  const userHasProducts = user && !!user.products.length;
  if (!userHasProducts) return null;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H5, {
        style: {
          display: 'inline-block',
          marginRight: 8
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.profile.productUsage"
        })
      }), ownProfile && /*#__PURE__*/_jsx(UILink, {
        href: hubspotEditPagePaths.edit(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.edit"
        })
      })]
    }), user.products.map(product => /*#__PURE__*/_jsx(ProductTag, {
      inline: screenLarge,
      className: "m-right-3",
      product: product
    }, product))]
  });
};

export default UserProducts;